import { render, staticRenderFns } from "./loginRecord.vue?vue&type=template&id=9a236c92&scoped=true"
import script from "./loginRecord.vue?vue&type=script&lang=js"
export * from "./loginRecord.vue?vue&type=script&lang=js"
import style0 from "./loginRecord.vue?vue&type=style&index=0&id=9a236c92&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a236c92",
  null
  
)

export default component.exports